import { View, Text as PDFText } from '@react-pdf/renderer'

import { Policies } from '../../../../../types/bookingDetails'
import styles from './styles/index.styles'

interface CancelTermsAndConditionsProps {
  cancelPolicies: Policies[]
  cancelPolicyDescription: string[]
  splitTextByWords(inputString: string, maxLength: number): string[]
}

export const CancelTermsAndConditions = ({
  cancelPolicies,
  cancelPolicyDescription,
  splitTextByWords
}: CancelTermsAndConditionsProps) => {
  const somethingToShow = cancelPolicies.some((ele) => ele.deadline <= 4320)

  if (somethingToShow || cancelPolicyDescription.length > 0) {
    return (
      <View style={styles.mainDiv} wrap={false}>
        <View style={styles.titleContainer}>
          <PDFText style={styles.mainTitle}>شرایط و مقررات کنسلی</PDFText>
        </View>
        {cancelPolicyDescription.length > 0
          ? cancelPolicyDescription.map((item) => {
              const segments = splitTextByWords(item, 105)
              return segments.map((segment, segIndex) => (
                <View
                  key={segIndex}
                  style={
                    segIndex === 0
                      ? styles.singleParagraph
                      : styles.singleParagraphShort
                  }>
                  <View style={styles.title}>
                    <PDFText style={styles.piece}>
                      {segment.replace(/\(|\)/g, ($1) => {
                        return $1 === ')' ? '(' : ')'
                      })}
                    </PDFText>
                  </View>
                </View>
              ))
            })
          : cancelPolicies.map((item, index) => {
              switch (item.policyType) {
                case 'ReservationTime':
                  if (item.deadline > 4320) {
                    return (
                      <View key={item.policyType + index.toString()}></View>
                    )
                  }
                  return (
                    <View
                      key={item.policyType + index.toString()}
                      style={styles.singleParagraph}>
                      <View style={styles.title}>
                        <PDFText style={styles.piece}>
                          {item.deadline % 24 === 0
                            ? Math.floor(item.deadline / 24)
                            : item.deadline}{' '}
                        </PDFText>
                        <PDFText style={styles.piece}>
                          {item.deadline % 24 === 0 ? 'روز' : 'ساعت'}{' '}
                        </PDFText>
                        <PDFText style={styles.piece}>
                          {' '}
                          بعد از زمان رزرو:{' '}
                        </PDFText>
                      </View>
                      <View style={styles.description}>
                        <PDFText style={styles.piece}>
                          {item.penaltyAmount}%{' '}
                        </PDFText>
                        <PDFText style={styles.piece}>از </PDFText>
                        <PDFText style={styles.piece}>
                          {item.penaltyType === 'FirstNight'
                            ? 'هزینه شب اول '
                            : 'قیمت کل '}
                        </PDFText>
                        <PDFText style={styles.piece}>
                          به عنوان جریمه کسر خواهد شد.
                        </PDFText>
                      </View>
                    </View>
                  )
                case 'CheckInTime':
                  if (item.deadline > 4320) {
                    return (
                      <View key={item.policyType + index.toString()}></View>
                    )
                  }
                  return (
                    <View
                      key={item.policyType + index.toString()}
                      style={styles.singleParagraph}>
                      <View style={styles.title}>
                        <PDFText style={styles.piece}>کمتر از </PDFText>
                        <PDFText style={styles.piece}>
                          {' '}
                          {item.deadline % 24 === 0
                            ? Math.floor(item.deadline / 24)
                            : item.deadline}
                        </PDFText>
                        <PDFText style={styles.piece}>
                          {item.deadline % 24 === 0 ? 'روز' : 'ساعت'}{' '}
                        </PDFText>
                        <PDFText style={styles.piece}>
                          {' '}
                          قبل از زمان ورود:{' '}
                        </PDFText>
                      </View>
                      <View style={styles.description}>
                        <PDFText style={styles.piece}>
                          %{item.penaltyAmount}{' '}
                        </PDFText>
                        <PDFText style={styles.piece}>از</PDFText>
                        {item.penaltyType === 'FirstNight' ? (
                          <PDFText style={styles.piece}>هزینه شب اول </PDFText>
                        ) : (
                          <PDFText style={styles.piece}>قیمت کل </PDFText>
                        )}
                        <PDFText style={styles.piece}>
                          به عنوان جریمه کسر خواهد شد.
                        </PDFText>
                      </View>
                    </View>
                  )
                case 'AfterCheckInTime':
                  if (item.deadline > 4320) {
                    return (
                      <View key={item.policyType + index.toString()}></View>
                    )
                  }
                  return (
                    <View
                      key={item.policyType + index.toString()}
                      style={styles.singleParagraph}>
                      <View style={styles.title}>
                        <PDFText style={styles.piece}>کمتر از </PDFText>
                        <PDFText style={styles.piece}>
                          {' '}
                          {item.deadline % 24 === 0
                            ? Math.floor(item.deadline / 24)
                            : item.deadline}
                        </PDFText>
                        <PDFText style={styles.piece}>
                          {item.deadline % 24 === 0 ? 'روز' : 'ساعت'}{' '}
                        </PDFText>
                        <PDFText style={styles.piece}>
                          {' '}
                          بعد از زمان ورود:{' '}
                        </PDFText>
                      </View>
                      <View style={styles.description}>
                        <PDFText style={styles.piece}>
                          {item.penaltyAmount}%
                        </PDFText>
                        <PDFText style={styles.piece}>از </PDFText>
                        <PDFText style={styles.piece}>
                          {item.penaltyType === 'FirstNight'
                            ? 'هزینه شب اول '
                            : 'قیمت کل '}
                        </PDFText>
                        <PDFText style={styles.piece}>
                          به عنوان جریمه کسر خواهد شد.
                        </PDFText>
                      </View>
                    </View>
                  )
                case 'BeforeCheckOutTime':
                  if (item.deadline > 4320) {
                    return (
                      <View key={item.policyType + index.toString()}></View>
                    )
                  }
                  return (
                    <View
                      key={item.policyType + index.toString()}
                      style={styles.singleParagraph}>
                      <View style={styles.title}>
                        <PDFText style={styles.piece}>کمتر از </PDFText>
                        <PDFText style={styles.piece}>
                          {' '}
                          {item.deadline % 24 === 0
                            ? Math.floor(item.deadline / 24)
                            : item.deadline}
                        </PDFText>
                        <PDFText style={styles.piece}>
                          {item.deadline % 24 === 0 ? 'روز' : 'ساعت'}{' '}
                        </PDFText>
                        <PDFText style={styles.piece}>
                          {' '}
                          قبل از زمان خروج:{' '}
                        </PDFText>
                      </View>
                      <View style={styles.description}>
                        <PDFText style={styles.piece}>
                          {item.penaltyAmount}%
                        </PDFText>
                        <PDFText style={styles.piece}>از </PDFText>
                        <PDFText style={styles.piece}>
                          {item.penaltyType === 'FirstNight'
                            ? 'هزینه شب اول '
                            : 'قیمت کل '}{' '}
                        </PDFText>
                        <PDFText style={styles.piece}>
                          به عنوان جریمه کسر خواهد شد.
                        </PDFText>
                      </View>
                    </View>
                  )
                default:
                  return <View></View>
              }
            })}
      </View>
    )
  }
  return <div />
}
